import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/chevron-left.svg";
var ChevronLeftSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ChevronLeftSolid_default as default
};
